const rouConfig = [
  {
    path: 'reserve',
    name: 'reserve',
    meta: {
      name: '预订',
    },
    component: () => import('./reserve'),
  },
  {
    path: 'reserve/addreserve',
    name: 'addreserve',
    meta: {
      name: '预订',
    },
    component: () => import('./components/addreserve'),
  },

];

export default rouConfig;